// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__26VCl","info":"UpdateTermsInfo_info__1SMX8"};